import { getCookie } from '@rover/rsdk/src/modules/Network/cookies';
import { RoverBrand } from '@rover/types/src/RoverBrand';

const ROVER_BRAND_COOKIE_NAME = 'rover_brand';

const getRoverBrand = (): RoverBrand => {
  const roverProperty = getCookie(ROVER_BRAND_COOKIE_NAME);
  if (roverProperty && Object.values(RoverBrand).includes(roverProperty as RoverBrand)) {
    return roverProperty as RoverBrand;
  }
  return RoverBrand.Rover; // Default to Rover if cookie is not set or invalid
};

export default getRoverBrand;
